import { z } from 'zod';
import { PASSWORD_VALIDATION_KEYS } from 'app/components/PasswordValidationPoints';
import {
  hasForbiddenWhitespace,
  PASSWORD_LOWERCASE,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_NUMBER,
  PASSWORD_SYMBOL,
  PASSWORD_UPPERCASE,
} from 'app/utils/passwordPolicy';

const ValidationScheme = {
  Email: z
    .string()
    .trim()
    .min(1, { message: 'validation.emailRequired' })
    .email({ message: 'validation.emailInvalid' }),
  RequiredString: (
    options: { message: string } = {
      message: 'validation.fieldRequired',
    },
  ) =>
    z.string().trim().min(1, {
      message: options.message,
    }),
  ValidPassword: z
    .string()
    .max(PASSWORD_MAX_LENGTH, { message: 'validation.password.maxLength' })
    .min(PASSWORD_MIN_LENGTH, { message: PASSWORD_VALIDATION_KEYS.length })
    .refine((password) => PASSWORD_UPPERCASE.test(password), {
      message: PASSWORD_VALIDATION_KEYS.uppercase,
    })
    .refine((password) => PASSWORD_LOWERCASE.test(password), {
      message: PASSWORD_VALIDATION_KEYS.lowercase,
    })
    .refine((password) => PASSWORD_NUMBER.test(password), {
      message: PASSWORD_VALIDATION_KEYS.number,
    })
    .refine((password) => PASSWORD_SYMBOL.test(password), {
      message: PASSWORD_VALIDATION_KEYS.symbol,
    })
    .refine((password) => !hasForbiddenWhitespace(password), {
      message: 'validation.password.edgeWhitespace',
    }),
};

export default ValidationScheme;
